var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCategoryMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 10.75H3A1.752 1.752 0 0 1 1.25 9V5A1.752 1.752 0 0 1 3 3.25h4A1.752 1.752 0 0 1 8.75 5v4A1.752 1.752 0 0 1 7 10.75zm-4-6a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4A.25.25 0 0 0 7.25 9V5A.25.25 0 0 0 7 4.75zM7 20.75H3A1.752 1.752 0 0 1 1.25 19v-4A1.752 1.752 0 0 1 3 13.25h4A1.752 1.752 0 0 1 8.75 15v4A1.752 1.752 0 0 1 7 20.75zm-4-6a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zM22 5.75H12a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5zM18 9.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5zM22 15.75H12a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5zM18 19.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCategoryMaster);
export default __webpack_public_path__ + "static/media/product-category-master.76c26431a19e881b6845342ddcd67c56.svg";
export { ForwardRef as ReactComponent };